import {type QueryHookOptions} from '@apollo/client';

import {FetchInstitutions} from '../../graphql/queries/fetch-institutions.query';
import {
    type FetchInstitutionsQuery,
    type FetchInstitutionsQueryVariables,
} from '../../graphql/queries/__generated__/fetch-institutions.query.api-types-no-enum';
import {type ImmerWrappedQueryResult} from '../use-immer-query-wrapper';
import {useStatQuery} from './use-stat-query';

export function useFetchInstitutionsQuery(
    options: QueryHookOptions<FetchInstitutionsQuery, FetchInstitutionsQueryVariables>,
): ImmerWrappedQueryResult<FetchInstitutionsQuery, FetchInstitutionsQueryVariables> {
    return useStatQuery<FetchInstitutionsQuery, FetchInstitutionsQueryVariables>(FetchInstitutions, options);
}
